import {
    AccountsSelectionPagePath,
    HomePagePath,
    LoginPagePath,
    ProductionsSelectionPagePath,
} from './constants';
import { ProtectionLevel } from './types/ProtectionLevels';

interface RedirectRule {
    level: ProtectionLevel;
    path: string;
}

const redirectPriority: RedirectRule[] = [
    {
        level: ProtectionLevel.NONE,
        path: HomePagePath,
    },
    {
        level: ProtectionLevel.AUTHENTICATED,
        path: LoginPagePath,
    },
    {
        level: ProtectionLevel.ACCOUNT_SELECTED,
        path: AccountsSelectionPagePath,
    },
    {
        level: ProtectionLevel.PRODUCTION_SELECTED,
        path: ProductionsSelectionPagePath,
    },
];

export const getRedirectPathToLastAllowedGate = (
    protectionLevel: ProtectionLevel,
    requiredProtectionLevel: ProtectionLevel,
) => {
    const redirectRule = redirectPriority.find(
        (rule) =>
            requiredProtectionLevel & rule.level &&
            !(protectionLevel & rule.level),
    );

    if (redirectRule) {
        return redirectRule.path;
    }

    return HomePagePath;
};
